import React, { useEffect, useState, useRef } from 'react';
import { getHistorial } from '../services/database';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './CalendarCustom.css'; // Crearemos este archivo para el estilo

const Timeline = () => {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState(new Date());
  
  // Referencias para el scroll automático
  const eventosRefs = useRef({});

  useEffect(() => {
    const fetchData = async () => {
      const data = await getHistorial();
      const ordenados = data.sort((a, b) => {
        const [diaA, mesA, anioA] = a.fecha_evento.split('-').map(Number);
        const [diaB, mesB, anioB] = b.fecha_evento.split('-').map(Number);
        return new Date(anioA, mesA - 1, diaA) - new Date(anioB, mesB - 1, diaB);
      });
      setEventos(ordenados);
      setLoading(false);
    };
    fetchData();
  }, []);

  // Función para manejar el clic en el calendario
  const onChange = (nextDate) => {
    setDate(nextDate);
    const fechaString = `${nextDate.getDate().toString().padStart(2, '0')}-${(nextDate.getMonth() + 1).toString().padStart(2, '0')}-${nextDate.getFullYear()}`;
    
    // Si existe un evento en esa fecha, hacemos scroll
    if (eventosRefs.current[fechaString]) {
      eventosRefs.current[fechaString].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  // Función para marcar días con eventos en el calendario
  const tileClassName = ({ date, view }) => {
    if (view === 'month') {
      const fechaString = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
      if (eventos.some(e => e.fecha_evento === fechaString)) {
        return 'has-event'; // Clase CSS personalizada
      }
    }
    return null;
  };

  if (loading) return <div className="p-10 text-center font-bold">Cargando bitácora médica...</div>;

  return (
    <div className="max-w-6xl mx-auto p-4 flex flex-col md:flex-row gap-8">
      
      {/* COLUMNA IZQUIERDA: CALENDARIO (FIJO) */}
      <div className="md:w-1/3">
        <div className="sticky top-10 bg-white p-4 rounded-2xl shadow-xl border border-blue-50">
          <h2 className="text-xl font-bold mb-4 text-blue-800">Calendario de Eventos</h2>
          <Calendar 
            onChange={onChange} 
            value={date} 
            tileClassName={tileClassName}
            locale="es-ES"
          />
          <div className="mt-4 text-xs text-gray-500">
            <span className="inline-block w-3 h-3 bg-blue-500 rounded-full mr-2"></span>
            Días marcados tienen registros médicos.
          </div>
        </div>
      </div>

      {/* COLUMNA DERECHA: TIMELINE */}
      <div className="md:w-2/3">
        <h1 className="text-3xl font-black text-gray-800 mb-8 px-4">Historial de Papá</h1>
        <div className="relative border-l-4 border-blue-400 ml-4 md:ml-8">
          {eventos.map((evento) => (
            <div 
              key={evento.id} 
              ref={el => eventosRefs.current[evento.fecha_evento] = el}
              className="mb-10 ml-8 relative transition-all duration-500"
            >
              <div className="absolute -left-[42px] top-1.5 w-6 h-6 rounded-full bg-blue-500 border-4 border-white shadow-md"></div>
              
              <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-2xl transition-shadow">
                <div className="bg-blue-50 px-5 py-3 border-b border-blue-100 flex justify-between items-center">
                  <span className="text-sm font-bold text-blue-700 bg-white px-3 py-1 rounded-full shadow-sm">
                    {evento.fecha_evento}
                  </span>
                  <span className="text-[10px] font-black uppercase tracking-widest text-blue-400">
                    {evento.categoria}
                  </span>
                </div>

                <div className="p-5">
                  <h3 className="text-xl font-bold text-gray-800 mb-1">{evento.titulo}</h3>
                  <p className="text-sm text-blue-500 font-semibold mb-3">{evento.institucion}</p>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">{evento.descripcion_detallada}</p>

                  {evento.indicadores_alerta && (
                    <div className="flex flex-wrap gap-2 mb-4">
                      {Object.entries(evento.indicadores_alerta).map(([key, val]) => (
                        <div key={key} className="bg-red-50 border border-red-100 p-2 rounded-lg text-center min-w-[70px]">
                          <p className="text-[9px] text-red-400 font-bold uppercase">{key}</p>
                          <p className="text-sm font-black text-red-700">{val}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  {evento.medicamentos_nuevos && (
                    <div className="flex flex-wrap gap-2 pt-3 border-t border-gray-50">
                      {evento.medicamentos_nuevos.map((med, idx) => (
                        <span key={idx} className="bg-green-100 text-green-700 text-[10px] font-bold px-3 py-1 rounded-full">
                          {med}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Timeline;